import './InputWithPlusMinusButtons.pcss';
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

type Props = {
  initialValue: number;
  onChange: (value: number) => void;
  className?: string;
  lowerBound: number;
};

export const InputWithPlusMinusButtons = ({
  initialValue,
  onChange,
  className,
  lowerBound,
}: Props) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!initialValue) {
      return;
    }
    setValue(initialValue);
  }, [initialValue]);

  const updateValue = (newValue: number) => {
    setValue(newValue);
    onChange(newValue);
  };

  const inc = () => {
    const newValue = value + 1;
    updateValue(newValue);
  };

  const dec = () => {
    const newValue = value - 1;
    if (newValue >= lowerBound) {
      updateValue(newValue);
    }
  };

  return (
    <div className={classnames('number-input-with-buttons', className)}>
      <button onClick={dec} />
      <input
        className=""
        min="0"
        name="quantity"
        value={value}
        type="number"
        onChange={e => updateValue(Number(e.target.value))}
      />
      <button onClick={inc} className="plus" />
    </div>
  );
};
